module.exports = "/static/assets/17c87f84cd427b624fad0fe085015075.png";